
import Http from './base-http'

class WorkScheduleRequest extends Http {
  
}

const workScheduleRequest = new WorkScheduleRequest({
  modelUrlPrefix : 'WorkScheduleRequest'
})

export default workScheduleRequest
